export default "__VITE_ASSET__BUD34NBH__"